import {deploymentEnv, isCsmDeployment} from '~utils/deploymentEnv';

const isDevelopmentEnvironment = import.meta.env.NODE_ENV === 'development';
const isTestEnvironment = import.meta.env.NODE_ENV === 'test';
const isProductionBuild = import.meta.env.NODE_ENV === 'production';
const isE2eBuild = import.meta.env.VITE_E2E === 'true';

/**
 * Opt in to the real LaunchDarkly client while running `yarn dev`, so targeting rules (for example
 * the internal-users segment) can be verified locally instead of every flag being forced on.
 * The dev and staging client IDs point at the same LaunchDarkly environment.
 */
const forceLaunchDarklyInDev = import.meta.env.VITE_LD_ENABLE_IN_DEV === 'true';

/**
 * Preview deployments (per-PR Static Web App environments) should surface in-development,
 * flag-gated features so reviewers can exercise them, mirroring `yarn dev`. Set via preview.yml.
 */
const isPreviewDeployment = deploymentEnv.startsWith('preview');

/**
 * Whether the LaunchDarkly provider is mounted at all. Never mounted in tests, and not on the CSM
 * deployment: CSMs should see every feature regardless of its production rollout, so flags come
 * from the static defaults there (see `shouldForceAllFlagsEnabled`) and no LaunchDarkly environment
 * needs to know about CSM.
 *
 * Deliberately kept in its own module: `~utils/featureFlags` is mocked in a lot of tests, and
 * `src/main.tsx` reads this at module scope.
 */
export const shouldMountLaunchDarkly =
  !isE2eBuild && !isTestEnvironment && !isCsmDeployment && (isProductionBuild || forceLaunchDarklyInDev);

/** Whether flag values come from the static defaults instead of LaunchDarkly. */
export const shouldForceAllFlagsEnabled =
  isE2eBuild || isCsmDeployment || ((isDevelopmentEnvironment || isPreviewDeployment) && !forceLaunchDarklyInDev);
